export enum AuthorityBankConciliation {
  BANK_CONCILIATION = '3.9.1',
}
